import React from "react";
import { CTA_COPY } from "./heroContent";

const CtaButton = ({ onClick, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`px-8 py-4 text-lg font-bold text-white rounded-lg bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-400 hover:to-red-500 transition-all duration-300 shadow-fiery-glow-lg hover:shadow-[0_0_40px_rgba(255,95,109,0.65),0_0_80px_rgba(255,95,109,0.35)] btn-pulse-fiery btn-shine-fiery font-heading ${className}`}
    data-testid="hero-cta"
  >
    {CTA_COPY.button}
  </button>
);

const HeroCtaSection = ({ onOpenSignup, entryLine }) => (
  <div className="mt-6" data-testid="hero-cta-section">
    <CtaButton onClick={onOpenSignup} className="w-full" />
    <p
      className="text-xs text-gray-500 mt-2 text-center font-body"
      data-testid="landing-catalog-price"
    >
      {entryLine}
    </p>
  </div>
);

export default HeroCtaSection;
